// Tag icons. Each Tag persists one of these kebab-case names on `tags.icon`
// (see Tag::ICONS on the Rails side — keep the two lists in sync). The map
// resolves a stored name to its lucide-react component for rendering.
import {
  Tag,
  Hash,
  Star,
  Heart,
  Flag,
  Bookmark,
  Zap,
  Flame,
  Sparkles,
  Lightbulb,
  Rocket,
  Target,
  Trophy,
  Bell,
  Calendar,
  Mail,
  FileText,
  Bird,
  Megaphone,
  TvMinimalPlay,
  SmartphoneCharging,
  Video,
  Mic,
  Music,
  PenTool,
  Code,
  Globe,
  Users,
  MessageCircle,
  Gift,
  type LucideIcon,
} from "lucide-react"

// Order here drives the icon picker grid. The kebab keys mirror Tag::ICONS.
export const TAG_ICONS: Record<string, LucideIcon> = {
  tag: Tag,
  hash: Hash,
  star: Star,
  heart: Heart,
  flag: Flag,
  bookmark: Bookmark,
  zap: Zap,
  flame: Flame,
  sparkles: Sparkles,
  lightbulb: Lightbulb,
  rocket: Rocket,
  target: Target,
  trophy: Trophy,
  bell: Bell,
  calendar: Calendar,
  mail: Mail,
  "file-text": FileText,
  bird: Bird,
  megaphone: Megaphone,
  "tv-minimal-play": TvMinimalPlay,
  "smartphone-charging": SmartphoneCharging,
  video: Video,
  mic: Mic,
  music: Music,
  "pen-tool": PenTool,
  code: Code,
  globe: Globe,
  users: Users,
  "message-circle": MessageCircle,
  gift: Gift,
}

export const TAG_ICON_NAMES = Object.keys(TAG_ICONS)

// Resolves a stored icon name to its component, falling back to the generic
// Tag glyph for an unknown / missing name.
export function tagIcon(name: string | null | undefined): LucideIcon {
  if (!name) return Tag
  return TAG_ICONS[name] ?? Tag
}
